import { ChartTime, timeToTimestamp } from '../../services/timeframe-utils';

export const toNumericTimeOrNull = (time: ChartTime): number | null => {
  const timestamp = timeToTimestamp(time);
  return timestamp == null ? null : Number(timestamp);
};

export const toSortableTime = (time: ChartTime): number =>
  toNumericTimeOrNull(time) ?? Number.POSITIVE_INFINITY;

export const serializeNumericTime = (time: ChartTime, prefix = 't'): string => {
  const numeric = toNumericTimeOrNull(time);
  return numeric == null ? `${prefix}:na` : `${prefix}:${numeric}`;
};
